import axios from 'axios';

async function moveInKitties(txn) {
  if (!txn) {
    throw new Error('No txn provided');
  }

  await axios.post(
    '/api/cities/move-in',
    {
      txn,
    },
    {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_API_KEY,
      },
    }
  );
}

export default moveInKitties;
